import React, { useState, useRef } from 'react'
import { Input, Icon, Text } from '@components/UI'
import { useFileUpdate } from '../../hooks'
import { useClassroomPermissions } from '../../contexts'
import { Classroom as CC } from '../../../../constants'

const Tab = ({ id, active, activate, name, close }) => {
  const { mutateAsync: updateFile } = useFileUpdate()
  const [initial, setInitial] = useState(null)
  const [newName, setNewName] = useState(null)
  const input = useRef(null)

  const { checkPermission } = useClassroomPermissions()
  const canSwitchFile = checkPermission(CC.FEATURES.TOOL_SWITCH_FILE)
  const canRenameFile = checkPermission(CC.FEATURES.TOOL_RENAME_FILE)

  return (
    <div
      className={`tab ${active ? 'active' : ''}`}
      onClick={() => {
        if (canSwitchFile) activate()
      }}
    >
      {initial === name ? (
        <Input
          autoFocus
          reference={input}
          defaultValue={name}
          events={{
            onChange: (v) => setNewName(v),
            onBlur: () => {
              const reset = () => {
                setInitial(null)
                setNewName(null)
              }
              if (newName !== name && newName) {
                updateFile({
                  id,
                  data: {
                    name: {
                      action: 'replace',
                      value: newName
                    }
                  }
                }).then(() => {
                  reset()
                })
              } else {
                reset()
              }
            },
            onKeyPress: (e) => {
              if (e.key === 'Enter') input.current.blur()
            }
          }}
        />
      ) : (
        <Text className='text-c'>{name}</Text>
      )}
      <div className='tab-controls'>
        {canRenameFile ? (
          <Icon
            name='pencil'
            events={{
              onClick: (e) => {
                setInitial(name)
                setNewName(name)
                e.stopPropagation()
              }
            }}
          />
        ) : null}
        {canSwitchFile ? (
          <Icon
            name='close'
            events={{
              onClick: (e) => {
                close()
                e.stopPropagation()
              }
            }}
          />
        ) : null}
      </div>
    </div>
  )
}

export default Tab
